// Phase E — claims API hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useClaimTypes = () =>
  useQuery({
    queryKey: ["claim-types"],
    queryFn: () => axios.get(`${API}/claims/types`).then((r) => r.data),
    staleTime: 1000 * 60 * 30,
  });

export const useClaims = (params = {}, enabled = true) =>
  useQuery({
    queryKey: ["claims", params],
    queryFn: () => axios.get(`${API}/claims`, { params }).then((r) => r.data),
    enabled,
  });

export const useCreateClaim = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => axios.post(`${API}/claims`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["claims"] }),
  });
};

export const useUpdateClaimStatus = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ claimId, status, note }) =>
      axios.patch(`${API}/claims/${claimId}/status`, { status, note }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["claims"] }),
  });
};

export const useUploadClaimEvidence = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ claimId, files }) => {
      const fd = new FormData();
      files.forEach((f) => fd.append("files", f));
      return axios.post(`${API}/claims/${claimId}/evidence`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then((r) => r.data);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["claims"] }),
  });
};
